import { $get } from '../axios';

// 工作室首页-经营概况-前两个数据
export const getStudioIncomeOverview = params => {
  return $get('/creator/', {
    act: 'get_studio_income_overview',
    ...params,
  });
};
// 工作室首页-流水趋势-折线图
export const getStudioIncomeDiagram = params => {
  return $get('/creator/', {
    act: 'get_studio_income_diagram',
    ...params,
  });
};
// 工作室首页-成员动态
export const getStudioMemberHistory = params => {
  return $get('/studio/', { cmd: 'studio_get_history', ...params });
};
// 工作室首页 获取7日作品数据
export const getOneWeekProductData = params => {
  return $get('/studio/', { cmd: 'studio_query_maps_detail', ...params });
};
// 工作室首页 获取7日作品数据排行
export const getOneWeekProductRank = params => {
  return $get('/studio/', { cmd: 'studio_query_maps_rank', ...params });
};
// 工作室首页-数据详情-作品数据
export const getStudioProductIncome = params => {
  return $get('/creator/', {
    act: 'get_studio_product_income',
    ...params,
  });
};
//工作室首页-数据详情-作品数据-互动数据
export const getStudioProductView = params => {
  return $get('/studio/', {
    act: 'get_studio_members_product_data_interaction',
    ...params,
  });
};
//工作室首页-数据详情-作品数据-转化数据
export const getExposureDataList = params => {
  return $get('/creator/', {
    act: 'get_studio_product_ad_exposure',
    ...params,
  });
};
// 工作室首页-数据详情-成员收益数据
export const getStudioMembersIncome = params => {
  return $get(
    '/creator/',
    {
      act: 'get_studio_members_income',
      ...params,
    },
    { timeout: 300000 },
  );
};
//工作室首页-数据详情-成员互动数据
export const getStudioMembersOverview = params => {
  return $get('/studio/', {
    act: 'get_studio_members_product_interaction',
    ...params,
  });
};
// 获取工作室详情
export const getStudioDetail = params => {
  return $get('/studio/', { cmd: 'studio_query_detail', ...params });
};
// 获取工作室详情
export const updateStudioProfile = params => {
  return $get('/studio/', { cmd: 'studio_change_profile', ...params });
};
// 工作室首页-工作室管理-获取工作室状态
export const getStudioStatus = params => {
  return $get('/studio/', { cmd: 'studio_get_status', ...params });
};
// 工作室首页-工作室管理-获取工作室成员列表
export const getStudioMembers = params => {
  return $get('/studio/', { cmd: 'studio_get_member', ...params });
};
// 工作室首页-工作室管理-加入退出列表
export const getStudioRequest = params => {
  return $get('/studio/', { cmd: 'studio_get_request', ...params });
};
// 工作室首页-工作室管理-删除成员
export const delStudioMember = params => {
  return $get('/studio/', { cmd: 'studio_kick_member', ...params });
};
// 工作室首页-工作室管理-设置成员
export const setStudioMember = params => {
  return $get('/studio/', { cmd: 'studio_change_member_profile', ...params });
};
// 工作室首页-工作室管理-审核：通过/拒绝
export const studioRequestAudit = params => {
  return $get('/studio/', { cmd: 'studio_request_audit', ...params });
};
// 工作室首页-工作室设置-获取工作室列表
export const getStudioList = params => {
  return $get('/studio/', { cmd: 'query_studio_list', ...params });
};
// 工作室首页-工作室设置-获取验证码
export const getVerCode = params => {
  return $get('/creator/', { act: 'get_vercode', op: 4, ...params });
};
// 工作室首页-工作室设置-校验验证码
export const authVerCode = params => {
  return $get('/creator/', { act: 'auth_vercode', op: 4, ...params });
};
// 工作室首页-工作室设置-请求认证工作室
export const studioRequestVip = params => {
  return $get('/studio/', { cmd: 'studio_request_vip', ...params });
};
// 工作室首页-工作室设置-修改认证工作室
export const studioChangeVip = params => {
  return $get('/studio/', { cmd: 'studio_change_vip_detail', ...params });
};
// 工作室首页-工作室设置-请求认证工作室  [已废置]
export const studioUpdateVip = params => {
  return $get('/studio/', { cmd: 'studio_get_vip_detail', ...params });
};
// 工作室首页-工作室设置-请求认证工作室(条件检查)
export const checkStudioRegisterStatus = params => {
  return $get('/studio/', { cmd: 'studio_pre_register', ...params });
};
// 工作室首页-工作室设置-注册工作室
export const studioRegister = params => {
  return $get('/studio/', { cmd: 'studio_register', ...params });
};
// 工作室首页-普通成员-获取工作室成员数量
export const getStudioMemberCount = params => {
  return $get('/studio/', { cmd: 'studio_get_member_count', ...params });
};
// 工作室首页-普通成员-获取工作室作品列表
export const getStudioProductList = params => {
  return $get('/studio/', { cmd: 'studio_get_maps_list', ...params });
};
//工作室-工作室管理-添加成员邀请入口
export const addStudioMemberInvite = params => {
  return $get('/studio/', { cmd: 'studio_invite_member', ...params });
};
// 工作室概况-数据明细-普通成员-工作室概况表-互动表
export const getStudioOverview = params => {
  return $get('/studio/', {
    act: 'get_studio_overview_interaction',
    ...params,
  });
};
// 工作室概况-数据明细-普通成员-工作室概况表-收益表
export const getStudioDayIncomeData = params => {
  return $get('/creator/', { act: 'get_studio_day_income', ...params });
};
//工作室首页-查看详情-成员作品详情
export const getProductDetailData = params => {
  return $get('/studio/', { act: 'get_studio_product_interaction', ...params });
};
//工作室首页-查看详情-成员作品收入
export const getProductDeatilIncome = params => {
  return $get('/creator/', {
    act: 'get_studio_member_product_income',
    ...params,
  });
};
//工作室首页-工作室概况-数据导出
export const exportStudioOverview = params => {
  return $get('/studio/', {
    act: 'export_studio_overview_interaction',
    ...params,
  });
};
//工作室首页-个人详情-成员数据导出
export const exportStudioInteraction = params => {
  return $get('/studio/', {
    act: 'export_studio_product_interaction',
    ...params,
  });
};
//工作室首页-个人详情-个人数据概览
export const getStudioMembersOverviewData = params => {
  return $get('/creator/', { act: 'get_studio_members_overview', ...params });
};
//工作室首页-个人详情-个人数据导出
export const InExportStudioInteraction = params => {
  return $get('/creator/', {
    act: 'export_studio_member_product_income',
    ...params,
  });
};
//工作室首页-个人详情-个人信息介绍
export const getStudioMemBaseinfo = params => {
  return $get('/studio/', { act: 'get_studio_member_base_info', ...params });
};
//工作室首页-工作室概况-收益数据导出
export const exportStudioIncome = params => {
  return $get('/creator/', { act: 'export_studio_income', ...params });
};
//工作室管理-成员管理-获取成员权限
// export const getPermiss = params => {
//   return $get('/studio/', { cmd: 'studio_query_detail', ...params });
// };
//工作室管理-成员管理-更新成员权限
export const setPermiss = params => {
  return $get('/studio/', { cmd: 'studio_set_data_perm', ...params });
};

const STUDIO_DETAIL_INFO_CACHE_KEY = 'STUDIO_DETAIL_INFO_CACHE_KEY';
let STUDIO_DETAIL_INFO_REQUESTING = false;
export const getPermiss = params => {
  const userInfo = JSON.parse(sessionStorage.getItem('userInfo')) || {};
  const { uin } = userInfo;
  if (STUDIO_DETAIL_INFO_REQUESTING) {
    // 延迟请求
    return new Promise(resolve => {
      let timer = setInterval(() => {
        if (!STUDIO_DETAIL_INFO_REQUESTING) {
          clearInterval(timer);
          resolve(getPermiss(params));
        }
      }, 150);
    });
  }
  let data = sessionStorage.getItem(STUDIO_DETAIL_INFO_CACHE_KEY + uin);
  if (data) {
    return Promise.resolve(JSON.parse(data));
  } else {
    STUDIO_DETAIL_INFO_REQUESTING = true;
    return $get('/studio/', { cmd: 'studio_query_detail', ...params }).then(
      res => {
        const {
          allow_join,
          apply_time,
          audit_time,
          company_name,
          leader_uin,
          level,
          position,
          state,
          v0m_active,
          v1m_active,
          v1m_income,
          vip,
          vip_audit,
          vip_member,
        } = res.data;
        const dataToChache = {
          allow_join,
          apply_time,
          audit_time,
          company_name,
          leader_uin,
          level,
          position,
          state,
          v0m_active,
          v1m_active,
          v1m_income,
          vip,
          vip_audit,
          vip_member,
        };
        STUDIO_DETAIL_INFO_REQUESTING = false;
        sessionStorage.setItem(
          STUDIO_DETAIL_INFO_CACHE_KEY + uin,
          JSON.stringify({ code: 0, data: dataToChache }),
        );
        return res;
      },
    );
  }
};
